export const USER_ROLES = ['USER', 'STAFF', 'MANAGER', 'ADMIN'] as const;
export type UserRole = typeof USER_ROLES[number];
export type UserStatus = 'ACTIVE' | 'INACTIVE';

export interface AdminUser {
  id: number;
  username: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  avatarUrl: string | null;
  address: string | null;
  role: UserRole;
  permissions: string[];
  active: boolean;
  createdAt: string;
}

export interface AdminUserPage {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
  data: AdminUser[];
}

export interface UserStatistics {
  total: number;
  user: number;
  staff: number;
  manager: number;
  admin: number;
}

export interface AdminUserQuery {
  search?: string;
  role?: UserRole;
  status?: UserStatus;
  page: number;
  size: number;
  sort: string;
}

export interface CreateUserInput {
  username: string;
  password: string;
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  address?: string;
  avatarUrl?: string;
  roleType: UserRole;
}

export type UpdateUserInput = Omit<CreateUserInput, 'password'>;

export type UserFormValues = CreateUserInput;
